// Dependencies

import React from 'react';

import classnames from 'classnames';
// eslint-disable-next-line lodash/import-scope
import { map } from 'lodash';
import PropTypes from 'prop-types';

// Components
import { ElementImpression } from '@nerdwallet/nw-client-lib/tracking';
import ConfigBuilder from '@nerdwallet/react-config-builder';

// Local components
import BreakdownDetails from '../breakdown-details/breakdown-details';

// CSS
require('./dti-details.less');

class DTIDetails extends React.Component {
  renderTitle(titleConfig) {
    const data = this.props.data;

    return (
      <div className="dti-details-title">
        {map(titleConfig, (config, i) => (
          <ConfigBuilder
            key={`dti-details-title-${i}`}
            data={data}
            viewConfig={config}
          />
        ))}
      </div>
    );
  }

  renderBreakdownDetails(data, items) {
    return (
      <ElementImpression
        id="mortgages-hac-dti-details"
        elementName="mortgages-hac-dti-details"
      >
        <div className="breakdown-details-container">
          <p>{this.props.scenarioHeader}</p>
          <BreakdownDetails
            className="dti-details-breakdown"
            data={data}
            config={items}
          />
        </div>
      </ElementImpression>
    );
  }

  render() {
    const { browser, config, data } = this.props;
    const { title, items } = config;

    const classNames = classnames({
      mobile: browser.isMobile || browser.isTablet,
      desktop: !browser.isMobile && !browser.isTablet,
    });

    return (
      <div className={classNames}>
        <div className="dti-details">
          {this.renderTitle(title)}
          {this.renderBreakdownDetails(data, items)}
          <p>
            *DTI is the main way lenders decide how much you can spend on a
            mortgage.
          </p>
        </div>
      </div>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
DTIDetails.displayName = 'DTIDetails';

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
DTIDetails.propTypes = {
  config: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  scenarioHeader: PropTypes.string.isRequired,
  browser: PropTypes.shape({
    isMobile: PropTypes.bool,
    isTablet: PropTypes.bool,
  }).isRequired,
};

export default DTIDetails;
